<template>
  <section :class="warpClass" :style="`background-color: ${backgroundColor}`">
    <div v-if="compProps.mode!=='4'" :class="(compProps.mode === mode.swiperCol || compProps.mode === mode.swiperFiveImgCol ? 'swiper-wrapper wrapper-width' : '')">
      <div class="exclusiveHouseTip" v-if="isShowExclusiveHouseTip">
        <img src="https://pic.tujia.com/upload/festatic/2412/430fc2233e6c6d62.png" class="exclusive-empty-img"/>
        <p>房屋太火爆！近30日都已被订光，为您推荐这家民宿～</p>
      </div>
      <div
        :class="(compProps.mode === mode.swiperCol || compProps.mode === mode.swiperFiveImgCol ? 'swiper-slide' : '')"
        data-actionid="3"
        :data-itemtext="item.unitName"
        :data-itemotherinfo="item.unitId"
        @click="openHouseInfo($event, item.unitId, index, item)"
        class="house-warp"
        v-for="(item, index) in compProps.items"
        :key="index"
        data-growing-container
      >
        <!-- 房屋不可订的白色蒙层 -->
        <lazy-component v-if="compProps.mode === mode.singleCol || compProps.mode === mode.singleCommentCol" class="house-imgs-warp swiper-containers lazy-load-component tjf-img-bg unit-swiper-item" @show="lazyLoadShow(item,$event)" :key="item.unitId">
            <div v-if="!item.allowBooking" class="house-img-mask__fully">
              <img width="100%" v-lazy="`${baseUrl}static/imgs/fully_booked.png`" class="empty-img">
            </div>
            <img v-if="compProps.privateProps&&compProps.privateProps.atmosphere" class="atmosphere-icon" :src="compProps.privateProps&&(picHost + compProps.privateProps.atmosphere)">
            <!-- 取自房屋列表的氛围暂时取消 -->
            <div class="swiper-wrapper">
              <div v-for="(image, index) in item.pictureList" :key="index" class="swiper-slide unit-swiper-item">
                <img width="100%" :data-src="image" @error="imgErrorHandle" class="swiper-lazy">
              </div>
            </div>
        </lazy-component>
        <!-- 5张图-swiper-模式 -->
        <div v-else-if="compProps.mode === mode.swiperFiveImgCol" class="house-imgs-warp">
          <img v-if="compProps.privateProps&&compProps.privateProps.atmosphere" class="atmosphere-icon" :src="compProps.privateProps&&(picHost + compProps.privateProps.atmosphere)">
          <div class="multi-imgs-container">
            <div class="five-imgs-wrapper">
              <div class="img-row img-row-1">
                <div class="img-wrapper img-wrapper--main tjf-img-bg" v-lazy:background-image="{src: item.pictureList[0]}" :style="{ backgroundSize: 'cover', backgroundPosition: 'bottom center'}" :key="imgKey(item.pictureList[0], index)">
                </div>
                <div class="img-wrapper tjf-img-bg"  v-lazy:background-image="item.pictureList[1]" :style="{backgroundSize: 'cover', backgroundPosition: 'bottom center'}" :key="imgKey(item.pictureList[1], index)">
                </div>
              </div>
              <div class="img-row">
                <div class="img-column-left">
                  <div class="img-wrapper tjf-img-bg"  v-lazy:background-image="item.pictureList[2]"  :style="{backgroundSize: 'cover', backgroundPosition: 'bottom center'}" :key="imgKey(item.pictureList[2], index)">
                  </div>
                  <div class="img-wrapper tjf-img-bg"  v-lazy:background-image="item.pictureList[3]"  :style="{ backgroundSize: 'cover', backgroundPosition: 'bottom center'}" :key="imgKey(item.pictureList[3], index)">
                  </div>
                </div>
                <div class="img-wrapper img-column-right tjf-img-bg"  v-lazy:background-image="item.pictureList[4]"  :style="{backgroundSize: 'cover', backgroundPosition: 'bottom center'}" :key="imgKey(item.pictureList[4], index)">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="house-imgs-warp">
          <img v-if="compProps.privateProps&&compProps.privateProps.atmosphere" class="atmosphere-icon" v-lazy="compProps.privateProps&&(picHost + compProps.privateProps.atmosphere)">
          <!-- 取自房屋列表的氛围暂时取消 -->
          <div ref="ratioWH" class="other-mode" v-resize="resize">
            <img width="100%" v-lazy="item.defaultPicture" @load="imgLoadHandle" @error="imgErrorHandle" class="tjf-img-bg" :key="item.unitId">
            <div class="tag" v-if="isQ20220709101555">京郊住宿券</div>
          </div>
        </div>
        <div class="house-detail-warp" :class="{isFivePic: compProps.mode === mode.swiperFiveImgCol}">
            <!-- 房屋不可订 -->
          <div v-if="!item.allowBooking">
            <div v-if="compProps.mode == mode.singleCol || compProps.mode == mode.singleCommentCol" class="house-detail-booking-btn">
              <div class="house-detail-booking-btn-text">去订其他日期</div>
              <img :src="`${baseUrl}static/imgs/right_icon.png`" class="house-detail-booking-btn-img" />
            </div>
            <div v-else class="house-img-mask__empty">
              <img width="100%" v-lazy="`${baseUrl}static/imgs/empty-house-mask@3x.png`" class="empty-img__small">
            </div>
          </div>
          <div class="house-detail-tags" v-if="item.hasSpecialTags">
            <div class="detail-tag-1" v-for="(item, index) in item.specialTags" :key="index">{{item.name}}</div>
          </div>
          <div class="house-detail-name house-detail-name-diamond" :class="unitNameClass" v-if="!(compProps.privateProps&&compProps.privateProps.isHideHouseName)">
            <div class="house-detail-name-box">{{item.unitName}}</div>
          </div>
          <div class="house-detail-unit">
            <label v-for="summer in item.unitSummeries" :key="summer.text">{{ summer.text }}</label>
          </div>
          <div>
            <div class="house-detail-price">
              <div class="detail-price-now">¥{{item.finalPrice || item.productPrice}}</div>
              <div class="detail-price-before" v-if="item.finalPrice < item.productPrice">¥{{item.productPrice}}</div>
              <div :class="compProps.mode === mode.swiperCol || compProps.mode === mode.swiperFiveImgCol ? 'detail-price-reason' : 'detail-price-reasonoverflow'">
                <label v-for="tag in item.priceTags" :key="tag.text">{{tag.text || tag.name }}</label>
                <label v-if="item.priceTags && item.priceTags.length <= 0 &&item.hasPriceTags" style="background-color: transparent;">{{' '}}</label>
              </div>
            </div>
          </div>
          <div v-if="compProps.mode === mode.doubleColNoTime && !houseFilter.checkInDate" class="doubleColNoTime">{{item.bookingDateTips}}</div>
          <div v-if="compProps.mode === mode.singleCommentCol" class="house-detail-desc">{{item.comment}}</div>
        </div>
        <div
          class="favorate-icon"
          :style="`background-image: url('${baseUrl === '/'?'':baseUrl}${item.isLike?'/static/imgs/favorite-red.png': '/static/imgs/favorite-clear.png'}')`"
          @click.stop="favorite(item.unitId, item.isLike, index, item)"
        ></div>
      </div>
    </div>
    <!-- 榜单渲染模式 -->
    <div v-else>
      <div
        data-actionid="3"
        :data-itemtext="item.unitName"
        :data-itemotherinfo="item.unitId"
        @click="openHouseInfo($event, item.unitId, index, item)"
        class="house-warp house-mode"
        v-for="(item, index) in compProps.items"
        :key="index"
        data-growing-container
      >
        <!-- 筛选项内的房屋卡片目前使用的渲染方式 -->
        <div class="house-imgs-warp">
          <div class="multi-imgs-container">
            <!-- 3张图模式 -->
            <div class="three-imgs-wrapper">
              <div class="img-column img-column--main">
                <img width="100%" v-lazy="item.pictureList[0]" @error="imgErrorHandle" class="tjf-img-bg" :key="imgKey(item.pictureList[0], index)">
                <div class="img-column__bg"></div>
              </div>
              <div class="img-column img-column--right">
                <div class="img-wrapper">
                  <img width="100%" v-lazy="item.pictureList[1]" @error="imgErrorHandle" class="tjf-img-bg" :key="imgKey(item.pictureList[1], index)">
                </div>
                <div class="img-wrapper img-wrapper-bottom">
                  <img width="100%" v-lazy="item.pictureList[2]" @error="imgErrorHandle" class="tjf-img-bg" :key="imgKey(item.pictureList[2], index)">
                </div>
              </div>
              <div class="house-detail__price">
                <div class="detail-price__final" v-if="!item.finalPrice && !item.productPrice">当前售罄</div>
                <div class="detail-price__final" v-else-if="(item.finalPrice || item.productPrice) && !item.allowBooking">当前售罄</div>
                <div class="detail-price__final" v-else>￥{{item.finalPrice || item.productPrice}}</div>
                <div class="detail-price__before" v-if="item.finalPrice < item.productPrice">￥{{item.productPrice}}</div>
                <div class="detail-price__preferes">
                  <div class="detail-price__prefer" v-for="(tag,ikey) in item.priceTags" :key="ikey" v-show="!((item.finalPrice || item.productPrice) && !item.allowBooking)">
                    <span ref="tagDom">{{tag.text || tag.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="house-detail__warp">
          <div class="house-detail-name house-linehight" :class="unitNameClass" v-if="!(compProps.privateProps&&compProps.privateProps.isHideHouseName)">{{item.unitName}}</div>
          <div class="house-magin">
            <label v-for="summer in item.unitSummeries" :key="summer.text">{{ summer.text }}</label>
          </div>
          <div class="detail-tag__container clearfix">
            <div class="tag-item" v-for="(label,ikey) in item.houseLabels" :key="ikey">
              <span ref="tagDom">{{label.substring(0,8)}}</span>
            </div>
          </div>
          <div v-if="item.comment" class="detail-desc__container">{{item.comment}}</div>
        </div>
        <div
          class="favorate-icon"
          :style="`background-image: url('${baseUrl === '/'?'':baseUrl}${item.isLike?'/static/imgs/favorite-red.png': '/static/imgs/favorite-clear.png'}')`"
          @click.stop="favorite(item.unitId, item.isLike, index, item)"
        ></div>
      </div>
    </div>
    <div v-if="noHouse" class="emptyHouse">
      <img src="https://pic.tujia.com/upload/festatic/publicImages/cms_empty_house_img2x.png"/>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    compId: {
      type: String,
      default: function() {
        return ''
      }
    },
    compProps: {
      type: Object,
      default: function() {
        return {
          mode: '0',
          items: [],
          totalCount: 0,
          privateProps: {}
        }
      }
    }
  },
  data() {
    return {
      mode: {
        singleCol: '0',
        singleCommentCol: '1',
        doubleCol: '2',
        swiperCol: '3',
        threeImgCol: '4',
        swiperFiveImgCol: '5',
        // singleColTop: '6',
        doubleColNoTime: '7'
      },
      isMobile: false,
      ratio: 320 / 214,
      screenWidth: 375
    }
  },
  mounted() {
    this.isMobile = this.$root.isMobile
    this.screenWidth = document.body.clientWidth
  },
  computed: {
    ...mapState(['houseFilter']),
    warpClass() {
      switch (this.compProps.mode + '') {
      case '0':
        return 'single-col'
      case '2':
        return 'double-col'
      case '3':
        return 'swiper-col swiper-container'
      case '4':
        return 'single-col house-list__mode'
      case '5':
        return 'swiper-col swiper-container'
      case '1':
        return 'single-comment-col'
      // case '6':
      //   return 'single-col single-col-top'
      case '7':
        return 'double-col'
      default:
        return 'single-col'
      }
    },
    unitNameClass() {
      switch (this.compProps.mode + '') {
      case '1':
        return 'multi-unit'
      default:
        return 'single-unit'
      }
    },
    backgroundColor() {
      if (this.compProps.privateProps) {
        return this.compProps.privateProps.backgroundColor
      } else {
        return ''
      }
    },
    noHouse() {
      return this.compProps?.items?.length === 0
    },
    promotionId() {
      return this.$root.promotionId
    },
    /**
     * [是否安卓(安卓用line-height时居中有偏差)]
     */
    isAndriod() {
      const ua = navigator.userAgent
      // android终端
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1

      return isAndroid
    },
    isQ20220709101555() {
      return ['Q20220709101555'].indexOf(this.$route.query.id) > -1
    },
    isShowExclusiveHouseTip() {
      // 专属房源 & 30天无房源兜底提示
      return this.compProps?.privateProps?.houseChoice === '3' && String(this.$route?.query?.isNoHouseTips) === '1'
    }
  },
  watch: {
    compProps: {
      handler(newVal, oldVal) {
        const newArr = JSON.stringify(newVal.items)
        const oldArr = JSON.stringify(oldVal.items)
        if (newVal.items && !oldVal.items) {
          this.expourseData()
        }
        if (newArr !== oldArr && (newVal.mode === '0' || newVal.mode === '1')) {
          // 移除不用，转为lazyLoad再初始化
          // this.$nextTick(() => {
          //   eslint-disable-next-line
          //   this.swiper = new Swiper(`#comp_id_${this.compId} .house-imgs-warp`, {
          //     lazy: {
          //       loadPrevNext: true
          //     }
          //   })
          // })
        } else if (newArr !== oldArr && newVal.mode === '3') {
          this.$nextTick(() => {
            let space = 0
            const width = document.body.clientWidth
            if (width <= 720) {
              space = width / 375 * 20
            } else {
              space = 40
            }
            if (this.swiper) {
              this.swiper.update()
            } else {
              // eslint-disable-next-line
              this.swiper = new Swiper(`#comp_id_${this.compId} .swiper-col`, {
                slidesPerView: 'auto',
                spaceBetween: space
              })
            }
          })
        } else if (newArr !== oldArr && newVal.mode === '4') {
          this.$nextTick()
            .then(() => {
              if (this.isAndriod) {
                if (this.$refs.tagDom && this.$refs.tagDom.length) {
                  this.$refs.tagDom.forEach((item) => {
                    item.style.top = '1px'
                  })
                }
              }
            })
        } else if (newArr !== oldArr && newVal.mode === '5') {
          this.$nextTick(() => {
            let space = 0
            const width = document.body.clientWidth
            if (width <= 720) {
              space = width / 375 * 20
            } else {
              space = 40
            }
            if (this.swiper) {
              this.swiper.update()
            } else {
              // eslint-disable-next-line
              this.swiper = new Swiper(`#comp_id_${this.compId} .swiper-col`, {
                slidesPerView: 'auto',
                spaceBetween: space
              })
            }
          })
        }
      },
      deep: true
    }
  },
  methods: {
    expourseData() {
      let exposureData = []
      this.compProps && this.compProps.items && this.compProps.items.forEach((item, index) => {
        let items = {}
        items.house_id = item.unitId
        items.house_name = item.unitName
        items.position = index
        items.price = item.finalPrice
        items.city_id = item.cityId
        items.rank_list_id = this.$root.promotionId
        items.rank_list_name = document.title
        exposureData[index] = items
      })
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_RANKLIST_HOUSECARD_EXPOSURE',
        ext: {
          ...exposureData
        }
      })
    },
    imgLoadHandle() {
      this.$refs['ratioWH'].map((item) => {
        item.style.height = item.offsetWidth / this.ratio + 'px'
      })
    },
    // 监听dom元素
    resize() {
      this.$refs['ratioWH'].map((item) => {
        item.style.height = item.offsetWidth / this.ratio + 'px'
      })
    },
    imgErrorHandle($event) {
      $event.target.src = `${this.baseUrl}static/imgs/default.jpg`
      if (process.env.VUE_APP_LOCAL === 'M') {
        this.$refs['ratioWH'].map((item) => {
          item.style.backgroundColor = '#f8f8f8'
        })
        $event.target.style.display = 'none'
      }
    },
    imgKey(imgSrc, index) {
      if (imgSrc) {
        let arr = imgSrc.split('/')
        if (arr.length !== 0) {
          return arr[arr.length - 1]
        } else {
          return imgSrc
        }
      } else {
        return index
      }
    },
    /**
     * 异步加载图片Swiper组件，加载到再初始化
    */
    lazyLoadShow(item, event) {
      this.$nextTick(() => {
        // eslint-disable-next-line
        this.swiper = new Swiper(event.$el, {
          lazy: {
            loadPrevNext: true
          }
        })
      })
    },
    openHouseInfo($event, unitId, index, item) {
      this.$emit('action', { type: 'openHouseInfo', data: unitId, houseIndex: index, checkInDate: item.checkInDate, checkOutDate: item.checkOutDate })
      window._fas && window._fas.setCustomTrack({
        eventname: 'HOUSE_CLICK',
        ext: {
          house_id: unitId,
          house_rank: index + 1,
          city_id: item.cityId,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    },
    /**
     * [favorite 触发收藏/取消收藏事件]
     * @param unitId 房屋id
     * @param isLike {Boolean} 收藏/取消收藏
     * @param houseIndex {Number} 房屋索引
     */
    favorite(unitId, isLike, index, item) {
      this.$emit('action', { type: 'favoriteHouse', data: { id: unitId, isLike: isLike, houseIndex: index, itemData: item } })
      window._fas && window._fas.setCustomTrack({
        eventname: 'HOUSE_FAVORITE_CLICK',
        ext: {
          houseid: unitId,
          city_id: item.cityId,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    }
  },
  directives: {
    resize: {
      bind(el, binding) {
        let width = ''
        let height = ''
        function isReize() {
          const style = document.defaultView.getComputedStyle(el)
          if (width !== style.width || height !== style.height) {
            binding.value()
          }
          width = style.width
          height = style.height
        }
        el.__vueSetInterval__ = setInterval(isReize, 300)
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.house-warp {
  position: relative;
}

.single-comment-col,
.single-col {
  padding: 10px 0 0;
  overflow: hidden;
  .house-warp {
    margin: 0 1.25rem 1.25rem;
  }
  &.house-list__mode{
    padding: 1.33rem 0 0.05rem;
    .house-warp {
      margin: 0 1.25rem 1.33rem;
    }
  }
  // 榜单模式
  .house-mode{
    background: #FFFFFF;
    box-shadow: 0 2px 60px 5px rgba(0,0,0,0.07);
    border-radius: 0.8rem;
    // 榜单新增
    .multi-imgs-container {
      .three-imgs-wrapper {
        display: flex;
        flex-direction: row;

        .img-column--main {
          flex: 1 1 auto;
          width: 14.8rem;
          height: 14.8rem;
          position: relative;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .img-column__bg{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 4.33rem;
            background-image: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.30) 72%);
          }
        }
        .img-column--right {
          display: flex;
          flex-direction: column;
          margin-left: 2px;
          height: 14.8rem;

          .img-wrapper {
            width: 7.4rem;
            height: 7.4rem;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              -webkit-object-fit: cover;
              object-fit: cover;
            }
          }
          .img-wrapper:first-child {
            margin-bottom: 2px;
          }
        }
        // 价格
        .house-detail__price,
        .house-detail__empty {
          position: absolute;
          left: 20px;
          bottom: 7px;
          font-family: PingFangSC-Semibold;
          font-size: 1.2rem;
          color: #ffffff;
          display: flex;
          align-items: baseline;
          .detail-price__before {
            text-decoration: line-through;
            font-family: PingFangSC-Regular;
            font-size: 0.8rem;
            margin-left: .4rem;
          }
          .detail-price__preferes{
            width: 15rem;
            display: flex;
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            position: relative;
            margin-left: 8px;
            top: -4px;
            .detail-price__prefer{
              border: 1px solid #FFFFFF;
              font-family: PingFangSC-Regular;
              border-radius: 2px;
              margin-left: 0.4rem;
              font-size: 0.66rem;
              line-height: 1rem;
              padding: 0 .3rem;
            }
          }
          // 兼容chrome和safari
          .detail-price__preferes::-webkit-scrollbar{
            display: none;
          }
          // 兼容ie10+
          .detail-price__preferes {
            -ms-overflow-style: none
          }
          // 兼容firefox
          .detail-price__preferes {
            overflow: -moz-scrollbars-none;
          }
        }
      }
    }
    // 榜单新增
    .house-detail__warp{
      overflow: hidden;
      background-color: #fff;
      padding: 1.06rem 1.33rem;
      border-radius: 0 0 0.4rem 0.4rem;
      position: relative;
      .house-linehight{
        line-height: 1.46rem;
        margin-bottom: 0.45rem;
        font-family: PingFangSC-Medium;
        font-size: 1.06rem;
      }
      .house-magin{
        line-height: 1.06rem;
        font-family: PingFangSC-Regular;
        font-size: 0.8rem;
        color: #999999;
        letter-spacing: 0;
      }
      .detail-tag__container {
        margin-top: 0.2rem;
        font-family: PingFangSC-Medium;
        font-size: 0.66rem;
        color: #999999;
        .tag-item {
          padding: 2px 0.33rem;
          border: 1px solid #999999;
          border-radius: 2px;
          margin-bottom: 0.33rem;
          margin-right: 0.33rem;
          text-align: center;
          float: left;
          font-family: SourceHanSansCN-Normal;
          span{
            position: relative;
            top: 0.5px;
          }
        }
      }
      .detail-desc__container {
        font-family: PingFangSC-Regular;
        font-size: .8rem;
        margin-top: 0.66rem;
        color: #666666;
        letter-spacing: 0.92px;
        text-align: justify;
        line-height: 1.1rem;
      }
    }
    // end
  }
}

.double-col {
  padding: 10px 0.5rem 0;
  > div {
    display: flex;
    justify-content: space-between;
    flex-flow: wrap;
  }

  .unfavorate-icon,
  .favorate-icon {
    width: 1.4666rem;
    height: 1.3333rem;
    top: 10px;
    right: 1.1666rem;
  }

  .house-warp {
    width: 50%;
    padding: 0 0.5rem 1rem;
    box-sizing: border-box;
  }

  .house-detail-tags {
    display: none;
  }
  .house-detail-price,
  .house-detail-empty {
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .detail-price-reason {
    flex-shrink: 0;
    margin-top: 4px;
    width: 100%;
    > label {
      flex-shrink: 0;
    }
  }
  .doubleColNoTime {
    width: 200%;
    margin-top: 4px;
    font-family: PingFangSC-Regular;
    font-size: 22px;
    transform: scale(0.5);
    margin-bottom: -0.8rem;
    transform-origin: top left;
    color: #333333;
    letter-spacing: 0.85px;
    font-weight: 400;
  }
  .house-detail-desc {
    display: none;
  }
}

.swiper-col {
  padding: 10px 1.3333rem 1rem 1.3333rem;
  :global(.swiper-slide) {
    width: 19.8rem;
  }
}
.house-imgs-warp {
  position: relative;
  overflow: hidden;
  border-radius: 0.4rem 0.4rem 0 0;
  > div {
    width: 100%;
    background-color: #f3f3f3;
    font-size: 0;
  }
  .tag {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 0 0 0.26rem 0;
    color: #fff;
    font-size: .67rem;
    height: 1.3rem;
    line-height: 1.3rem;
    padding: 0 0.33rem;
    background: #f60;
  }
  .five-imgs-wrapper {
    display: flex;
    flex-direction: column;

    .img-row:first-child {
      margin-bottom: 2px;
      height: 151px;
    }
    .img-row {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 75px;

      .img-column-left {
        flex: 2 1 0;
        display: flex;
      }
      .img-column-right {
        margin-left: 2px;
        flex: 1 1 0;

        .img-wrapper {
          height: 100%;
        }
      }

      .img-wrapper {
        // flex: 1 1 auto;
        flex: 1 1 0;
        margin-left: 2px;
        background-size: cover;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .img-wrapper:first-child {
        margin-left: 0;
      }
    }
    .img-row-1 {
      .img-wrapper {
        flex: 1 1 0;
      }
      .img-wrapper--main {
        flex: 2 1 0;
      }
    }
  }

}

.atmosphere-icon {
  position: absolute;
  left: 0;
  bottom: 1rem;
  z-index: 9;
  height: 1.4rem;
}

.unfavorate-icon,
.favorate-icon {
  position: absolute;
  width: 1.4666rem;
  height: 1.3333rem;
  z-index: 1;
  background-size: contain;
  background-repeat: no-repeat;
  top: 0.9333rem;
  right: 0.9333rem;
}

.house-detail-warp {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  padding: 0.7rem 1rem;
  border-radius: 0 0 0.4rem 0.4rem;
}

.house-detail-booking-btn {
  background: #FF671D;
  border-radius: 4px;
  width: 108px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 8px;
  right: 8px;
  .house-detail-booking-btn-text {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 500;
    margin-right: 3px;
  }
  .house-detail-booking-btn-img {
    width: 5px;
    height: 8px;
  }
}

.detail-tag-1 {
  color: #ff6666;
  letter-spacing: 0;
  font-size: 10px;
  background-color: #feeded;
  border-radius: 2px;
  padding: 2px 3px;
  margin: 0 5px 2px 0;
  white-space: nowrap;
}

.detail-tag-2 {
  color: #f09e4f;
  letter-spacing: 0;
  font-size: 10px;
  background-color: #fff0d8;
  border-radius: 2px;
  padding: 2px 3px;
  margin-right: 5px;
  white-space: nowrap;
}

.house-detail-name {
  margin-bottom: 0.2rem;
  color: #333;
  letter-spacing: 0;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.single-unit {
    line-height: 1.2;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.multi-unit {
    line-height: 1.2;
  }
}
.house-detail-name-diamond {
  display: flex;
  align-items: center;
}

.house-detail-unit {
  width: 200%;
  margin-bottom: -0.2rem;
  color: #999;
  font-size: 22px;
  letter-spacing: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: scale(0.5);
  transform-origin: top left;
  white-space: nowrap;
  > label {
    margin-right: 5px;
  }
}

.house-detail-tags,
.house-detail-price,
.house-detail-empty {
  display: flex;
  margin-bottom: 0.4rem;
  align-items: baseline;
}

.detail-empty-text {
  height: 19px;
  font-size: 14px;
  color: #ff7248;
}

.house-detail-tags {
  flex-wrap: wrap;
  height: 16px;
  overflow: hidden;
}

.house-detail-price {
  margin-bottom: 0rem;
}

.detail-price-now {
  color: #ff6666;
  font-size: 16px;
  letter-spacing: 0;
  font-weight: 600;
  margin-right: 5px;
}

.detail-price-before {
  color: #999;
  font-size: 12px;
  letter-spacing: -1.2px;
  text-decoration: line-through;
  margin-right: 0.7rem;
  line-height: 1rem;
  height: 1rem;
}

.detail-price-reason {
  display: flex;
  flex-wrap: wrap;
  height: 18px;
  overflow: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  > label {
    color: #ff6666;
    font-size: 10px;
    background-color: #feeded;
    border-radius: 2px;
    letter-spacing: 0;
    padding: 2px 10px;
    margin-right: 5px;
    display: block;
    line-height: 16px;
    height: 18px;
    box-sizing: border-box;
  }
}
.detail-price-reasonoverflow {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  > label {
    color: #ff6666;
    font-size: 10px;
    background-color: #feeded;
    border-radius: 2px;
    letter-spacing: 0;
    padding: 2px 10px;
    margin-right: 5px;
    display: block;
    line-height: 16px;
    height: 18px;
    box-sizing: border-box;
  }
}
// 兼容chrome和safari
.detail-price-reasonoverflow::-webkit-scrollbar{
  width: 0!important
}
// 兼容ie10+
.detail-price-reasonoverflow {
  -ms-overflow-style: none
}
// 兼容firefox
.detail-price-reasonoverflow {
  overflow: -moz-scrollbars-none;
}

.house-detail-desc {
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
  color: #999;
  padding-top: 0.6rem;
}

.unit-swiper-item{
  padding-bottom:66.66%;
  height:0px;
  border-radius: 0.4rem 0.4rem 0 0;
  overflow: hidden;
}
.isFivePic {
  .house-detail-name{
    font-size: 16px;
    margin-bottom: .4rem;
    color: #333;
    letter-spacing: 0;
    font-weight: 700;
  }
  .house-detail-unit > label{
    color: #666;
  }
}
.house-detail-mask__empty {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.65);
  border-radius: .4rem;
}
.house-img-mask__empty {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255,255,255,0.65) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.4rem 0.4rem 0 0;
  z-index: 9;
  .empty-img {
    width: auto;
    height: 4.13rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
  }
  .empty-img__small {
    width: auto;
    height: 3.3rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
  }
}

.house-img-mask__fully {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0) !important;
  border-radius: 0.4rem 0.4rem 0 0;
  z-index: 9;
  .empty-img {
    width: auto;
    height: 64px;
    position: absolute;
    right: 8px;
    bottom: 10px;
  }
}
.house-detail-name-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.emptyHouse {
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  img {
    width: 100%;
  }
}

.exclusiveHouseTip {
  @extend .house-warp;
  padding: 0.53rem 0.8rem;
  display: flex;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.1);
  color: #FFFFFF;
  border-radius: 6px;
  margin-bottom: 16px!important;
  margin-top: -2px!important;
  .exclusive-empty-img {
    width: 18px;
    margin-right: 4px;
  }
}
</style>
